import { render } from "./PointHistorySp.vue?vue&type=template&id=453144da&scoped=true"
import script from "./PointHistorySp.vue?vue&type=script&lang=js"
export * from "./PointHistorySp.vue?vue&type=script&lang=js"

import "./PointHistorySp.vue?vue&type=style&index=0&id=453144da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-453144da"

export default script